import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LanguageAwareRoute = ({ children }) => {
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    // Extract language from URL path
    const pathSegments = location.pathname.split('/');
    const languageFromPath = pathSegments[1]; // First segment after /
    
    // Check if the first segment is a valid language code
    if (['en', 'de', 'fr'].includes(languageFromPath)) {
      // Set language if it matches URL
      if (i18n.language !== languageFromPath) {
        i18n.changeLanguage(languageFromPath);
      }
    } else if (pathSegments.length === 2 && pathSegments[1] === '') {
      // Root path (/) - don't change language
      // Let the language detector handle it
    }
  }, [location.pathname, i18n]);

  return children;
};

export default LanguageAwareRoute;
